import { useEffect, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { getDetailEmployee } from "../../../../store/employee";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import UpdateEmployee from "../update";
import Details from "./details/Details";
import SkeletonLoader from "./skeleton/SkeletonLoader";

interface Props {
  id: any;
  isShown: boolean;
}

const DetailEmployee = ({ id, isShown }: Props) => {
  const dispatch = useAppDispatch();
  const [edit, setEdit] = useState(false);

  const { status, detailEmployee } = useAppSelector((state) => state.employee);

  useEffect(() => {
    if (status === "updateEmployee_success") {
      dispatch(
        getDetailEmployee({
          id_encrypted: detailEmployee?.id_encrypted
            ? detailEmployee.id_encrypted
            : "",
        })
      );
    }
  }, [status]);

  useEffect(() => {
    if (isShown) {
      dispatch(getDetailEmployee({ id_encrypted: id ? id : "" }));
    }
  }, [isShown]);

  useEffect(() => {
    if (status === "updateEmployee_success") {
      setEdit(false);
    }
  }, [status]);

  const Edit = () => {
    setEdit(!edit);
  };

  if (status === "getDetailEmployee_loading") {
    return (
      <>
        <SkeletonLoader />
      </>
    );
  }

  return (
    <>
      <div className="c-page-profile">
        <div className="c-page-profile__body">
          <div className="c-profile-body">
            <div className="c-table__header">
              <span className="c-profile__title">Employee Information</span>
              <button className="c-table__button-secondary" onClick={Edit}>
                {edit ? "Cancel Edit" : "Edit Data"}
              </button>
            </div>
            {edit ? (
              <>
                {" "}
                <UpdateEmployee />{" "}
              </>
            ) : (
              <Details />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailEmployee;
